import { builderAPI } from "../../api/builderAPI"
import { parseSchemas } from "../../utility/parseSchemas"
import { ADD_SLICE, DELETE_SLICE, isFetchingAC, IS_FETCHING, resetStateAC, RESET_STATE, SAVE_ART_FORM_DATA, SAVE_CREDITS_FORM_DATA, SAVE_FILES_FORM_DATA, SAVE_SLICES_FORM_DATA } from "../actions/builderActions"

const initialState = {
    slices: {
        slice1: {
            value: '',
            hasAlt: false
        }
    },
    schemaString: '',
    slicesAmount: 0,
    parsedSchemas: [],
    files: null,
    artist: '',
    title: '',
    art: null,
    isFetching: false
}

export const builderReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SLICE:
            return {
                ...state,
                slicesAmount: ++state.slicesAmount,
                slices: {
                    ...state.slices, ['slice' + state.slicesAmount]: {
                        value: '',
                        hasAlt: false
                    }
                },
            }
        case DELETE_SLICE:
            let updatedSlices = {}
            Object.keys(state.slices)
                .filter(key => key !== action.sliceNumber)
                .forEach(sliceNumber => updatedSlices[sliceNumber] = { ...state.slices[sliceNumber] })
            return {
                ...state,
                slices: updatedSlices,
                slicesAmount: --state.slicesAmount
            }
        case SAVE_ART_FORM_DATA: {
            return {
                ...state,
                art: action.art
            }
        }
        case SAVE_SLICES_FORM_DATA:
            const savedSlices = JSON.parse(JSON.stringify(action.formData))
            let schemaString = ''
            Object.keys(savedSlices).forEach((key, index) => {
                schemaString += savedSlices[key].value
                if (index !== Object.keys(savedSlices).length - 1) {
                    schemaString += ' '
                }
            })
            const parsedSchemas = parseSchemas(schemaString)
            return {
                ...state,
                slices: savedSlices,
                schemaString: schemaString,
                parsedSchemas: parsedSchemas
            }
        case SAVE_CREDITS_FORM_DATA:
            return {
                ...state,
                artist: action.formData.artist,
                title: action.formData.title
            }
        case SAVE_FILES_FORM_DATA: {
            return {
                ...state,
                files: action.formData
            }
        }
        case IS_FETCHING:
            return {
                ...state,
                isFetching: action.isFetching
            }
        case RESET_STATE: {
            return initialState
        }

        default: return state
    }
}

export const publishSong = () => async (dispatch, getState) => {
    try {
        dispatch(isFetchingAC(true))
        const { files, schemaString, artist, title, art } = getState().builder
        await builderAPI.publishSongAPI(files, schemaString, artist, title, art)
        // dispatch(resetStateAC())
    } catch (e) {
        throw e
    } finally {
        dispatch(isFetchingAC(false))
    }
}